"use client"

import { useCollectionStatitstic } from "@/app/collections/statistic/use-floor"
import { Image } from "@/app/components/image"
import { PriceInCrypto } from "@/app/price"
import type {
  CollectionId,
  CollectionMiniature,
} from "@anaconda/core/nft-collection/types"
import { Trans, useLingui } from "@lingui/react/macro"
import { Card } from "@rarible_int/anaconda_ui_components"

interface Props {
  collection: CollectionMiniature
}

export function CollectionPreview({ collection: { image, name, id } }: Props) {
  const { t } = useLingui()

  return (
    <Card className="flex flex-col gap-4 p-4">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 shrink-0">
          <Image imageSrc={image} alt={t`Image for ${name} collection`} />
        </div>
        <div className="flex flex-col gap-1">
          {name}
          <CollectionStatistic collectionId={id} />
        </div>
      </div>
    </Card>
  )
}

function CollectionStatistic({ collectionId }: { collectionId: CollectionId }) {
  const { data: statistic = { floor: undefined, topOffer: undefined } } =
    useCollectionStatitstic(collectionId)
  const { floor, topOffer } = statistic

  if (!floor && !topOffer) return null

  return (
    <div className="flex flex-wrap items-center gap-[10px] text-foreground/60 text-xs">
      {floor && (
        <span>
          <Trans>Floor:</Trans>
          <PriceInCrypto {...floor} />
        </span>
      )}
      {topOffer && (
        <span>
          <Trans>Top offer:</Trans>
          <PriceInCrypto {...topOffer} />
        </span>
      )}
    </div>
  )
}
